import { Text } from 'components';
import React from 'react';
import { TableComponents } from 'screens/Admin/components';
import { ListItem } from './';

const List = ({ data, onClick, dataId, loading }) => {
  return (
    <TableComponents.List
      loading={loading || !data}
      Header={() => (
        <React.Fragment>
          <TableComponents.Th first>
            <Text>Owner</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Type</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Name</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Price</Text>
          </TableComponents.Th>

          <TableComponents.Th last>
            <Text>Published at</Text>
          </TableComponents.Th>
        </React.Fragment>
      )}
      Items={() =>
        !loading && data
          ? data.map((item, i) => (
              <ListItem key={i} dataId={dataId} onClick={onClick} item={item} />
            ))
          : null
      }
    />
  );
};

export default List;
